/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import * as PushUtils       from 'lib/PushUtils';
import * as DateUtils       from 'lib/DateUtils';
import Icon                 from 'components/Icon/Icon.react';
import prettyNumber         from 'lib/prettyNumber';
import PropTypes            from 'prop-types';
import PushAudiencesBaseRow from 'components/PushAudiencesSelector/PushAudiencesBaseRow.react';
import RadioButton          from 'components/RadioButton/RadioButton.react';
import React                from 'react';
import styles               from './PushAudiencesIndexRow.scss';
import stylesButton         from 'components/Button/Button.scss';

export default class PushAudiencesIndexRow extends PushAudiencesBaseRow {
  constructor() {
    super();
    this.state = {
      loading: true,
      count: undefined,
      approximate: false,
      isNewSegment: false,
    }
  }

  render() {
    // TODO: @pivanov we can show the details in other Audience Details Page
    // let conditions = PushUtils.largeInfoBuilder(this.props.query, this.props.schema, styles);
    // let detailsView = null;

    // if (conditions) {
    //   detailsView = this.state.expandedView ?
    //     <div className={styles.info}>{conditions}</div> : null
    // }

    let countDetails = PushUtils.formatCountDetails(this.state.count, this.state.approximate);

    return (
      <div className={styles.row}>
        <div className={styles.colName}>
          {this.props.name}
        </div>
        <div className={styles.colSize}>
          {countDetails}
        </div>
        {
          // TODO: @pivanov we can show the details in other Audience Details Page
          // <div className={styles.colSize}>
          //   {detailsView}
          //   <a
          //     role='button'
          //     href='javascript:;'
          //     className={[styles.moreDetails, !this.props.query ? styles.hideMoreDetails : ''].join(' ')}
          //     onClick={this.handleDetailsToggle.bind(this, this.props.query, this.props.schema)}>
          //     {this.state.expandedView ? 'less details' : 'more details' }
          //   </a>
          // </div>
        }
        <div className={styles.colCreatedOn}>
          {DateUtils.yearMonthDayFormatter(this.props.createdAt)}
        </div>
        <div className={styles.colPushesSent}>
          {this.props.timesUsed}
        </div>
        <div className={styles.colAction}>
          <a
            className={[stylesButton.tableButton, stylesButton.red].join(' ')}
            href='javascript:;'
            onClick={this.props.onDelete.bind(undefined, this.props.id, this.props.name)}>
            Delete
          </a>
          <a
            className={[stylesButton.tableButton, stylesButton.blue].join(' ')}
            href='javascript:;'
            onClick={this.props.onSendPush.bind(undefined, this.props.id)}>
            Send a new push
          </a>
        </div>
      </div>
    );
  }
}

PushAudiencesIndexRow.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  createdAt: PropTypes.instanceOf(Date),
  query: PropTypes.object,
  schema: PropTypes.object,
  timesUsed: PropTypes.number,
  onDelete: PropTypes.func,
  onSendPush: PropTypes.func,
};
